<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="40"
      height="40"
      rx="20"
      fill="#FFF7F2"
    />
    <g clip-path="url(#clip0_3592_498)">
      <path
        d="M29.8324 9.0361C29.7498 8.98513 29.6546 8.95801 29.5576 8.95801H13.8918C12.545 8.95801 11.4493 10.043 11.4493 11.3728L11.3572 24.8634H8.52607C8.2355 24.8634 8 25.0989 8 25.3895V27.8199C8.00185 29.6047 9.44813 31.0509 11.2329 31.053C11.269 31.053 11.3054 31.0493 11.341 31.0419H24.4116C24.4895 31.0474 24.568 31.0511 24.6471 31.0511C26.4596 31.0479 27.9272 29.5781 27.9278 27.7657V19.8795H31.4739C31.7644 19.8795 31.9999 19.644 31.9999 19.3535V11.5442C31.9936 10.2884 31.074 9.22413 29.8324 9.0361ZM9.05214 27.8201V25.9158H21.3663V27.7659C21.3657 28.5901 21.6758 29.3842 22.235 29.9898H11.1609C11.1361 29.99 11.1114 29.9918 11.087 29.9955C9.94256 29.9176 9.05358 28.9672 9.05214 27.8201ZM26.8757 11.5442V27.7657C26.8747 28.3538 26.641 28.9173 26.2257 29.3334C25.8281 29.7413 25.2878 29.9795 24.7186 29.9976C24.6902 29.9926 24.6615 29.9902 24.6325 29.99H24.4475C23.3017 29.8771 22.4261 28.9175 22.4185 27.7661V25.3895C22.4185 25.0991 22.183 24.8634 21.8924 24.8634H12.4093L12.5014 11.3765C12.509 10.6157 13.1308 10.0044 13.8918 10.0102H27.3983C27.0594 10.4497 26.8755 10.9891 26.8757 11.5442ZM30.9478 18.8274H27.9278V11.5442C27.9416 10.7199 28.6136 10.0593 29.4378 10.0593C30.2621 10.0593 30.934 10.7199 30.9478 11.5442V18.8274Z"
        fill="#040325"
      />
      <path
        d="M14.7541 14.6574H19.7365C20.0271 14.6574 20.2626 14.4219 20.2626 14.1313C20.2626 13.8407 20.0271 13.6052 19.7365 13.6052H14.7541C14.4635 13.6052 14.228 13.8407 14.228 14.1313C14.228 14.4219 14.4635 14.6574 14.7541 14.6574Z"
        fill="#040325"
      />
      <path
        d="M24.0483 17.3665H14.7541C14.4635 17.3665 14.228 17.602 14.228 17.8925C14.228 18.1829 14.4635 18.4186 14.7541 18.4186H24.0483C24.3388 18.4186 24.5743 18.1829 24.5743 17.8925C24.5743 17.602 24.3388 17.3665 24.0483 17.3665Z"
        fill="#040325"
      />
      <path
        d="M24.0483 21.1277H14.7541C14.4635 21.1277 14.228 21.3634 14.228 21.6538C14.228 21.9443 14.4635 22.1798 14.7541 22.1798H24.0483C24.3388 22.1798 24.5743 21.9443 24.5743 21.6538C24.5743 21.3634 24.3388 21.1277 24.0483 21.1277Z"
        fill="#040325"
      />
    </g>
    <defs>
      <clipPath id="clip0_3592_498">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(8 8)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
